var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": 'words'
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "words-container"
  }, [_c('assessment-helper'), _c('section', _vm._l(_vm.currentRound.words, function (word, index) {
    return _c('blinking-cursor-text', {
      key: ("step" + index),
      attrs: {
        "text": word,
        "text-step": index
      }
    });
  }), 1)], 1)])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }